const productDatabase = {
  1: {
    id: 1,
    title: "Elevator AMC Basic Plan",
    description: "Basic annual maintenance for residential elevators.",
    brand: "Otis",
    models: ["O-100", "O-200"],
    rawMaterials: ["Lubricant Oil", "Roller Guides", "Door Seals"],
    newParts: ["New PCB", "New Cabin Light", "Door Sensor"],
    oldParts: ["Old Controller Board", "Corroded Wires"],
    parts: [
      { id: 10, name: "Controller Board", price: 25000 },
      { id: 9, name: "Cabin Push Button", price: 500 },
      { id: 7, name: "Door Sensor", price: 2500 },
    ],
    relatedProducts: [2, 11, 12],
    image: "https://via.placeholder.com/400x300?text=AMC+Basic",
  },

  2: {
    id: 2,
    title: "Elevator AMC Premium Plan",
    description: "Premium annual maintenance for high-end elevators.",
    brand: "Schindler",
    models: ["S-500", "S-900"],
    rawMaterials: ["Steel Cabin", "Guide Rails", "Hydraulic Oil"],
    newParts: ["New Motor", "New Cabin Panels"],
    oldParts: ["Old Rail System"],
    parts: [
      { id: 11, name: "Elevator Modernization Kit", price: 95000 },
      { id: 12, name: "Elevator Cabin Interior Upgrade", price: 35000 },
    ],
    relatedProducts: [1, 3],
    image: "https://via.placeholder.com/400x300?text=AMC+Premium",
  },

  3: {
    id: 3,
    title: "Passenger Elevator",
    description: "Premium passenger elevator with smooth operation.",
    brand: "Otis",
    models: ["P-500", "P-900"],
    rawMaterials: ["Steel Cabin", "Guide Rails", "Hydraulic Oil"],
    newParts: ["New Motor", "New Cabin Panels"],
    oldParts: ["Old Rail System"],
    parts: [
      { id: 3, name: "Passenger Elevator", price: 350000 },
      { id: 8, name: "Display Panel", price: 3500 },
    ],
    relatedProducts: [2, 4, 15],
    image: "https://via.placeholder.com/400x300?text=Passenger+Elevator",
  },

  4: {
    id: 4,
    title: "Goods Elevator",
    description: "Heavy-duty elevator for goods and cargo.",
    brand: "Kone",
    models: ["G-1000", "G-2000"],
    rawMaterials: ["Steel Cabin", "Guide Rails"],
    newParts: ["Motor Replacement Kit"],
    oldParts: ["Old Gear System"],
    parts: [{ id: 4, name: "Goods Elevator", price: 420000 }],
    relatedProducts: [3, 15],
    image: "https://via.placeholder.com/400x300?text=Goods+Elevator",
  },

  5: {
    id: 5,
    title: "Hydraulic Elevator",
    description: "Hydraulic elevator for smooth vertical transportation.",
    brand: "ThyssenKrupp",
    models: ["H-200", "H-400"],
    rawMaterials: ["Hydraulic Cylinder", "Steel Cabin", "Guide Rails"],
    newParts: ["Hydraulic Pump", "Cylinder Replacement"],
    oldParts: ["Old Hydraulic Oil", "Worn Out Seals"],
    parts: [{ id: 5, name: "Hydraulic Elevator", price: 520000 }],
    relatedProducts: [3, 4],
    image: "https://via.placeholder.com/400x300?text=Hydraulic+Elevator",
  },

  6: {
    id: 6,
    title: "Hospital Stretcher Lift",
    description: "Elevator designed for hospital stretchers and patient beds.",
    brand: "Schindler",
    models: ["HS-500", "HS-900"],
    rawMaterials: ["Steel Cabin", "Guide Rails", "Safety Doors"],
    newParts: ["Motor Replacement", "Door Sensors"],
    oldParts: ["Old Rails", "Worn Cables"],
    parts: [{ id: 6, name: "Hospital Stretcher Lift", price: 650000 }],
    relatedProducts: [3, 5],
    image: "https://via.placeholder.com/400x300?text=Hospital+Lift",
  },

  7: {
    id: 7,
    title: "Elevator Door Sensor",
    description: "Sensor for detecting doors open/close status.",
    brand: "Otis",
    models: ["DS-100", "DS-200"],
    rawMaterials: ["Plastic Sensor Body", "Wires"],
    newParts: ["Sensor Replacement"],
    oldParts: ["Worn Sensor"],
    parts: [{ id: 7, name: "Elevator Door Sensor", price: 2500 }],
    relatedProducts: [1, 9, 10],
    image: "https://via.placeholder.com/400x300?text=Door+Sensor",
  },

  8: {
    id: 8,
    title: "Elevator Display Panel",
    description: "Display panel for elevator cabin floor info.",
    brand: "Kone",
    models: ["DP-100", "DP-200"],
    rawMaterials: ["LCD Panel", "Circuit Board"],
    newParts: ["New Panel"],
    oldParts: ["Old Panel"],
    parts: [{ id: 8, name: "Elevator Display Panel", price: 3500 }],
    relatedProducts: [3, 9, 10],
    image: "https://via.placeholder.com/400x300?text=Display+Panel",
  },

  9: {
    id: 9,
    title: "Elevator Push Button",
    description: "Cabin push button for elevator floors.",
    brand: "Otis",
    models: ["PB-100", "PB-200"],
    rawMaterials: ["Plastic", "Wiring"],
    newParts: ["Button Replacement"],
    oldParts: ["Worn Buttons"],
    parts: [{ id: 9, name: "Elevator Push Button", price: 500 }],
    relatedProducts: [1, 7, 8],
    image: "https://via.placeholder.com/400x300?text=Push+Button",
  },

  10: {
    id: 10,
    title: "Elevator Controller Board",
    description: "Controller board for elevator operations.",
    brand: "Otis",
    models: ["CB-100", "CB-200"],
    rawMaterials: ["PCB", "Microcontrollers", "Relay Boards"],
    newParts: ["Controller Replacement"],
    oldParts: ["Old Board"],
    parts: [{ id: 10, name: "Controller Board", price: 25000 }],
    relatedProducts: [1, 7, 8],
    image: "https://via.placeholder.com/400x300?text=Controller+Board",
  },

  11: {
    id: 11,
    title: "Elevator Modernization Kit",
    description: "Kit to modernize older elevators.",
    brand: "Schindler",
    models: ["MK-100", "MK-200"],
    rawMaterials: ["Steel Panels", "Wiring"],
    newParts: ["Motor Kit", "New Display"],
    oldParts: ["Old Panels"],
    parts: [{ id: 11, name: "Modernization Kit", price: 95000 }],
    relatedProducts: [1, 2, 12],
    image: "https://via.placeholder.com/400x300?text=Modernization+Kit",
  },

  12: {
    id: 12,
    title: "Elevator Cabin Interior Upgrade",
    description: "Upgrade the interior cabin for luxury feel.",
    brand: "Otis",
    models: ["CI-100", "CI-200"],
    rawMaterials: ["Wood Panels", "Lighting"],
    newParts: ["Lighting Kit", "Panel Replacement"],
    oldParts: ["Old Panels"],
    parts: [{ id: 12, name: "Cabin Interior Upgrade", price: 35000 }],
    relatedProducts: [1, 11],
    image: "https://via.placeholder.com/400x300?text=Cabin+Upgrade",
  },

  13: {
    id: 13,
    title: "Elevator Repair Service",
    description: "Repair service for elevator issues.",
    brand: "Kone",
    models: ["RS-100", "RS-200"],
    rawMaterials: [],
    newParts: [],
    oldParts: [],
    parts: [{ id: 13, name: "Repair Service", price: 2000 }],
    relatedProducts: [1, 2, 3],
    image: "https://via.placeholder.com/400x300?text=Repair+Service",
  },

  14: {
    id: 14,
    title: "Elevator Cable Replacement",
    description: "Replace old cables with new ones for safety.",
    brand: "ThyssenKrupp",
    models: ["CR-100", "CR-200"],
    rawMaterials: ["Steel Cables"],
    newParts: ["Cables"],
    oldParts: ["Old Cables"],
    parts: [{ id: 14, name: "Cable Replacement", price: 4500 }],
    relatedProducts: [1, 4, 5],
    image: "https://via.placeholder.com/400x300?text=Cable+Replacement",
  },

  15: {
    id: 15,
    title: "MRL (Machine Room Less) Elevator",
    description: "Modern MRL elevator without machine room.",
    brand: "Schindler",
    models: ["MRL-500", "MRL-900"],
    rawMaterials: ["Steel Cabin", "Guide Rails", "Motor Kit"],
    newParts: ["New Motor", "Panel Kit"],
    oldParts: ["Old Motor"],
    parts: [{ id: 15, name: "MRL Elevator", price: 480000 }],
    relatedProducts: [2, 3, 4],
    image: "https://via.placeholder.com/400x300?text=MRL+Elevator",
  },
};

export default productDatabase;
